import { Box, Checkbox, Grid, Link, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
// import Link from 'next/link';
import { styled } from '@mui/material/styles';
import { dataConstants } from '../../../constants';
import { getRandomStr, roundNum } from '../../../helpers';
// import getTickersInfo from '../../../../lib/stock/_getTickersInfo';
import { getPercent } from '../../../utils';
// import getLatestPrice from '../../../../lib/stock/_getLatestPrice';
// import groupBy from 'lodash/groupBy';
// const groupBy = (x, f) => x && x.reduce((a, b) => ((a[f(b)] ||= []).push(b), a), {});
// import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import Image from 'next/image';
import useSWR from 'swr';
import * as send from '../../../../lib/analytics/send';
import _getLatestPrice from '../../../../pages/api/_getLatestPrice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  // margin: theme.spacing(.5),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  '& a': { color: '#174c86' },
  '& .MuiTableContainer-root th': {
    background: '#fbfbfc',
    fontWeight: 600,
  },
  '& .MuiTableContainer-root::-webkit-scrollbar-thumb': {
    background: '#020e4a29',
    borderRadius: '1px'
  },
  '& .MuiTableContainer-root:hover::-webkit-scrollbar-thumb': {
    background: '#020e4a85',
    borderRadius: '1px'
  },
  '& .MuiTableContainer-root::-webkit-scrollbar-track': {
    background: '#f2f2f2',
    borderRadius: '1px'
  },
  '& .MuiTableContainer-root::-webkit-scrollbar': {
    width: '5px !important',
    height: '5px !important'
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: 'rgb(251 251 252)',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const convertData = (data) => {
  const result = data.reduce((acc, { ticker, short_name, r, p }) => {
    if (!acc[ticker]) {
      acc[ticker] = {
        ticker,
        short_name,
        price_data: [],
      };
    }

    acc[ticker].price_data.push({ price: p });

    return acc;
  }, {});

  return result;
}

// const getPercent = (a, b) => {
//   const percent = roundNum((a - b) * 100 / b, 2);
//   return percent >= 0 ? `+${percent}` : percent;
// }

// const roundNum = (num) => {
//   const n = num;
//   if (!n || isNaN(n)) return n;
//   return (Math.round(n * Math.pow(10, 2)) / Math.pow(10, 2)).toFixed(2);
// };

const latestPrice = (tickers) => {
  const { data, error, isLoading } = useSWR(["api/_getLatestPrice", tickers], _getLatestPrice, {
    keepPreviousData: true,
    refreshInterval: 420000,
    revalidateOnFocus: false,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
      if (error.status === 404) return
      // if (key === 'api/_getLatestPrice') return
      if (retryCount >= 10) return
      setTimeout(() => revalidate({ retryCount }), 5000)
    }
  }) || {}
  const { getLatestPrice: latestPrices } = data || {}
  const mergedData = React.useMemo(() => {
    if (!latestPrices) return tickers;
    return convertData(latestPrices);
  }, [latestPrices]);
  return { data: mergedData, error, isLoading };
};

const TodaysWinnersLosers = ({ tabs, todaysWinnersnLosers, }) => {
  const { wins, loss } = todaysWinnersnLosers && todaysWinnersnLosers !== "" ? JSON.parse(todaysWinnersnLosers) : {}
  // const [loading, setLoading] = useState(true);
  // const [stockPrice, setStockPrice] = useState(null)
  // useEffect(() => {
  //   if (todaysWinnersnLosers && todaysWinnersnLosers !== "") {
  //     getLatestPrice([...wins, ...loss], false).then(data => setStockPrice(convertData(data?.getLatestPrice))).catch(error => console.error(error)).finally(() => setLoading(false));;
  //   }
  // }, [todaysWinnersnLosers]);

  const { data: stockPrice, error, isLoading: loading } = latestPrice([...wins, ...loss]);

  return ((wins || loss) && (!error) &&
    <Box component="div" className="col-md-12">
      <Box component="div" className="s-card">
        {/* <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 0.5, px: 0.5, }} >
          <Typography component="h4" className="option-title" sx={{ mr: 'auto', fontWeight: 600, color: 'text.description' }} >Stocks in news</Typography>
        </Box> */}
        <Box component="div" className="option-content" sx={{ '& .MuiTableCell-root': { borderBottom: '1px solid #eae9ee', verticalAlign: "text-top" }, mt: 2 }}>
          <Box component="div" className="k">
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                {wins && wins.length > 0 ?
                  <Item>
                    <Box component="div" className="col-md-3">
                      {/* <CardContent sx={{ background: '#fbfbfc', borderRadius: '6px 6px 0 0', pb: 0 }}>
                        <Box component="div">
                          <Typography sx={{ fontSize: 14, fontWeight: 600, mr: 1.3, mb: .3 }} color="text.color.white">
                            {`Today's Winners`}
                          </Typography> */}
                      {/* <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', }} color="text.secondary">{`Stocks that have gained significantly in value today.`}</Typography> */}
                      {/* </Box>
                      </CardContent> */}
                      <TableContainer sx={{ maxHeight: 330, overflow: "auto" }}>
                        <Table stickyHeader aria-label={`winners-table`} size="small" >
                          <TableHead sx={{ background: '#fbfbfc', '& th': { color: 'text.secondary', fontSize: '.8rem', pr: 0 }, '& th:last-child': { pr: 2 }, }}>
                            <TableRow>
                              {/* <TableCell /> */}
                              <TableCell colSpan="2" sx={{ color: "#000 !important" }}>Today's Winners</TableCell>
                              <TableCell align="right">Price</TableCell>
                              <TableCell align="right">Chg %</TableCell>
                              <TableCell align="right">Chg.</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody
                            sx={{
                              // '& .ticker-name': { whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '8rem', display: 'block', overflow: 'hidden', }
                              '& .ticker-name': { whiteSpace: 'nowrap', position: 'absolutee', }
                            }}
                          >
                            {wins?.map((d, i) => {
                              const company = stockPrice ? stockPrice[d] : null
                              return (
                                ((d && loading) || (company && company?.price_data?.length > 0)) ?
                                  <StyledTableRow
                                    hover key={getRandomStr(7)}
                                    sx={{
                                      '&:last-child td, &:last-child th': { border: 0 },
                                      '& td': { pr: 0, }, '& td:last-child': { pr: 2 },
                                    }}
                                  >
                                    <TableCell padding="checkbox" sx={{ py: '5px !important' }}>
                                      <Checkbox
                                        aria-describedby={"enhanced-table"}
                                        sx={{ color: 'rgb(128,134,139)', '&:hover, &:hover.Mui-checked': { color: '#174ea6' }, '&.Mui-checked': { color: 'rgb(128,134,139)' } }}
                                        size="small"
                                        checked={false}
                                        onClick={(e) => e.preventDefault()}
                                        icon={<Image
                                          itemProp="logo" alt={""}
                                          src={`https://logo.grufity.com/${d ?? company?.ticker}.png`}
                                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                          quality={50}
                                          priority={false}
                                          loading='lazy'
                                          placeholder='empty'
                                          width={25}
                                          height={25}
                                          style={{
                                            height: 'auto',
                                            background: '#f8f9faxx', border: '1px solid rgb(218,231,224)xx',
                                            borderRadius: "5px", boxShadow: 0, color: '#174c86', '& img': { objectFit: 'contain', borderRadius: "4px" },
                                          }}
                                        />}
                                        // icon={<Avatar itemProp="logo" alt={d} variant="rounded" src={`https://logo.grufity.com/${d ?? company?.ticker}.png`}
                                        //   sx={{
                                        //     width: 25, height: 25, background: '#f8f9faxx', border: '1px solid rgb(218,231,224)xx',
                                        //     borderRadius: "5px", boxShadow: 0, color: '#174c86', '& img': { objectFit: 'contain', borderRadius: "4px" },
                                        //   }}>
                                        //   <ApartmentRoundedIcon sx={{ width: 25, height: 25, color: '#174ea6', }} />
                                        // </Avatar>}
                                        inputProps={{
                                          'aria-labelledby': d,
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="left" sx={{ color: 'text.secondary', whiteSpace: 'nowrap', position: 'relative', p: '0 !important', maxWidth: 177 }}>
                                      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', height: '100%', width: '100%' }}>
                                        <Link
                                          underline="hover"
                                          sx={{ fontWeight: 600 }}
                                          key={getRandomStr(3)} target="_blank"
                                          href={`${dataConstants.NAVS.STOCK}/${d}`}
                                          onClick={(e) => send.uevent(e)}
                                          data-event-name={'winners-table'} data-event-category="stock-homepage" data-event-label={`${dataConstants.NAVS.STOCK}/${d}`}
                                        >
                                          {d ?? company?.ticker}
                                        </Link>&nbsp;
                                        {!loading && <Typography component="p" className="ticker-name" sx={{
                                          fontSize: '.75rem', width: '100%', color: 'text.very_light_desc', whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                          overflow: 'hidden', mb: .11,
                                          display: { md: 'block', sm: 'none', xs: 'none' }
                                        }}>{company?.short_name}</Typography>}
                                      </Box>
                                    </TableCell>
                                    <TableCell align="right">
                                      {loading ? (
                                        <Skeleton animation="wave" height={15} width="75%" style={{ marginTop: 0, marginLeft: 'auto' }} />
                                      ) : company?.price_data?.length > 0 ? `$${roundNum(company?.price_data[0]?.price)}` : '-'}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: `${company?.price_data[0]?.price >= company?.price_data[1]?.price ? 'rgb(14, 158, 25)' : '#AB1C39'}` }}>
                                      {loading ? (
                                        <Skeleton animation="wave" height={15} width="75%" style={{ marginTop: 0, marginLeft: 'auto' }} />
                                      ) : company?.price_data?.length > 0 && company?.price_data[0]?.price && company?.price_data[1]?.price ? `${getPercent(company?.price_data[0]?.price, company?.price_data[1]?.price)}%` : '-'}
                                    </TableCell>
                                    <TableCell c align="right" sx={{ fontWeight: 600, color: `${company?.price_data[0]?.price >= company?.price_data[1]?.price ? 'rgb(14, 158, 25)' : '#AB1C39'}`, }}>
                                      {loading ? (
                                        <Skeleton animation="wave" height={15} width="75%" style={{ marginTop: 0, marginLeft: 'auto' }} />
                                      ) : company?.price_data[0]?.price - company?.price_data[1]?.price >= 0
                                        ? `+${roundNum(company?.price_data[0]?.price - company?.price_data[1]?.price)}`
                                        : company && company?.price_data[0]?.price && company?.price_data[1]?.price ? roundNum(company?.price_data[0]?.price - company?.price_data[1]?.price) : '-'}
                                    </TableCell>
                                  </StyledTableRow> : null)
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Item> : null}
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                {loss && loss.length > 0 ?
                  <Item>
                    <Box component="div" className="col-md-3">
                      {/* <CardContent sx={{ background: '#fbfbfc', borderRadius: '6px 6px 0 0', pb: 0 }}>
                        <Box component="div">
                          <Typography sx={{ fontSize: 14, fontWeight: 600, mr: 1.3, mb: .3 }} color="text.color.white">
                            {`Today's Losers`}
                          </Typography> */}
                      {/* <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', }} color="text.secondary">{`Stocks that have experienced substantial losses today.`}</Typography> */}
                      {/* </Box>
                      </CardContent> */}
                      <TableContainer sx={{ maxHeight: 330, overflow: "auto" }}>
                        <Table stickyHeader aria-label={`loasers-table`} size="small" >
                          <TableHead sx={{ background: '#fbfbfc', '& th': { color: 'text.secondary', fontSize: '.8rem', pr: 0 }, '& th:last-child': { pr: 2 }, }}>
                            <TableRow>
                              {/* <TableCell /> */}
                              <TableCell colSpan="2" sx={{ color: "#000 !important" }}>Today's Losers</TableCell>
                              <TableCell align="right">Price</TableCell>
                              <TableCell align="right">Chg %</TableCell>
                              <TableCell align="right">Chg.</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody
                            sx={{
                              // '& .ticker-name': { whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '8rem', display: 'block', overflow: 'hidden', }
                              '& .ticker-name': { whiteSpace: 'nowrap', position: 'absolutee', }
                            }}
                          >
                            {loss?.map((d, i) => {
                              const company = stockPrice ? stockPrice[d] : null
                              return (
                                ((d && loading) || (company && company?.price_data?.length > 0)) ?
                                  <StyledTableRow
                                    hover key={getRandomStr(4)}
                                    sx={{
                                      '&:last-child td, &:last-child th': { border: 0 },
                                      '& td': { pr: 0 }, '& td:last-child': { pr: 2 },
                                    }}
                                  >
                                    <TableCell padding="checkbox" sx={{ py: '5px !important' }}>
                                      <Checkbox
                                        aria-describedby={"enhanced-table"}
                                        sx={{ color: 'rgb(128,134,139)', '&:hover, &:hover.Mui-checked': { color: '#174ea6' }, '&.Mui-checked': { color: 'rgb(128,134,139)' } }}
                                        size="small"
                                        checked={false}
                                        onClick={(e) => e.preventDefault()}
                                        icon={<Image
                                          itemProp="logo" alt={""}
                                          src={`https://logo.grufity.com/${d ?? company?.ticker}.png`}
                                          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                          quality={50}
                                          priority={false}
                                          loading='lazy'
                                          placeholder='empty'
                                          width={25}
                                          height={25}
                                          style={{
                                            height: 'auto',
                                            background: '#f8f9faxx', border: '1px solid rgb(218,231,224)xx',
                                            borderRadius: "5px", boxShadow: 0, color: '#174c86', '& img': { objectFit: 'contain', borderRadius: "4px" },
                                          }}
                                        />}
                                        // icon={<Avatar itemProp="logo" alt={d} variant="rounded" src={`https://logo.grufity.com/${d ?? company?.ticker}.png`}
                                        //   sx={{
                                        //     width: 25, height: 25, background: '#f8f9faxx', border: '1px solid rgb(218,231,224)xx',
                                        //     borderRadius: "5px", boxShadow: 0, color: '#174c86', '& img': { objectFit: 'contain', borderRadius: "4px" },
                                        //   }}>
                                        //   <ApartmentRoundedIcon sx={{ width: 25, height: 25, color: '#174ea6', }} />
                                        // </Avatar>}
                                        inputProps={{
                                          'aria-labelledby': d,
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="left" sx={{ color: 'text.secondary', whiteSpace: 'nowrap', position: 'relative', p: '0 !important', maxWidth: 177 }}>
                                      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', height: '100%', width: '100%' }}>
                                        <Link
                                          underline="hover"
                                          sx={{ fontWeight: 600 }}
                                          key={getRandomStr(3)} target="_blank"
                                          href={`${dataConstants.NAVS.STOCK}/${d}`}
                                          onClick={(e) => send.uevent(e)}
                                          data-event-name={'winners-table'} data-event-category="stock-homepage" data-event-label={`${dataConstants.NAVS.STOCK}/${d}`}
                                        >
                                          {d ?? company?.ticker}
                                        </Link>&nbsp;
                                        {!loading && <Typography component="p" className="ticker-name" sx={{
                                          fontSize: '.75rem', width: '100%', color: 'text.very_light_desc', whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                          overflow: 'hidden', mb: .11,
                                          display: { md: 'block', sm: 'none', xs: 'none' }
                                        }}>{company?.short_name}</Typography>}
                                      </Box>
                                    </TableCell>
                                    <TableCell align="right">
                                      {loading ? (
                                        <Skeleton animation="wave" height={15} width="75%" style={{ marginTop: 0, marginLeft: 'auto' }} />
                                      ) : company?.price_data?.length > 0 ? `$${roundNum(company?.price_data[0]?.price)}` : '-'}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: `${company?.price_data[0]?.price >= company?.price_data[1]?.price ? 'rgb(14, 158, 25)' : '#AB1C39'}` }}>
                                      {loading ? (
                                        <Skeleton animation="wave" height={15} width="75%" style={{ marginTop: 0, marginLeft: 'auto' }} />
                                      ) : company?.price_data?.length > 0 && company?.price_data[0]?.price && company?.price_data[1]?.price ? `${getPercent(company?.price_data[0]?.price, company?.price_data[1]?.price)}%` : '-'}
                                    </TableCell>
                                    <TableCell c align="right" sx={{ fontWeight: 600, color: `${company?.price_data[0]?.price >= company?.price_data[1]?.price ? 'rgb(14, 158, 25)' : '#AB1C39'}`, }}>
                                      {loading ? (
                                        <Skeleton animation="wave" height={15} width="75%" style={{ marginTop: 0, marginLeft: 'auto' }} />
                                      ) : company?.price_data[0]?.price - company?.price_data[1]?.price >= 0
                                        ? `+${roundNum(company?.price_data[0]?.price - company?.price_data[1]?.price)}`
                                        : company && company?.price_data[0]?.price && company?.price_data[1]?.price ? roundNum(company?.price_data[0]?.price - company?.price_data[1]?.price) : '-'}
                                    </TableCell>
                                  </StyledTableRow> : null)
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Item> : null}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default (TodaysWinnersLosers)
